import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import PostMeta from "./post-meta"
import YouTubeIcon from "../icons/youtube-icon"

const Post = ({ post }) => {
  return (
    <div className="w-full">
      <div className="lg:flex lg:space-x-4 sm:space-y-4  mb-8">
        <div className="lg:w-1/3">
          <div className="relative">
            <Link to={`/blog/${post.slug}`} className="">
              <Image
                fluid={post.cover.fluid}
                alt={post.title}
                className="w-full h-full rounded-md overflow-hidden 
                           border-transparent absolute object-cover 
                           shadow-md hover:shadow-xl 
                           transition ease-in duration-300
                           transform hover:scale-105"
              />
            </Link>
          </div>
        </div>
        <div className="w-full mt-4 lg:mt-0 lg:w-2/3 px-4">
          <Link
            to={`/blog/${post.slug}`}
            className="text-gray-800 hover:text-gray-600 "
          >
            <h2 className="text-3xl mb-4">{post.title}</h2>
          </Link>
          <PostMeta post={post} />
          <p className="block mt-2 mb-4 text-lg font-light">
            {post.introContent.excerpt}
          </p>
          <Link
            to={`/blog/${post.slug}`}
            className="mt-4 py-2 px-4 rounded-full text-sm font-thin 
                       hover:bg-jnl-teal-medium hover:text-white
                       hover:shadow-lg text-jnl-teal-medium 
                       border-solid border border-jnl-teal-medium"
          >
            READ MORE
          </Link>
          {post.youTubeLink ? (
            <a
              href={post.youTubeLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 ml-2 py-2 px-4 rounded-full text-sm font-thin 
                         hover:bg-gray-500 hover:text-white hover:shadow-lg
                         text-gray-500 border-solid border border-gray-500"
            >
              <YouTubeIcon size="5" /> Watch Video
            </a>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Post
